import { FieldType } from "../api.js";
const PlaySpinTxModelConvertSpec = {
  targetAmt: FieldType.BigNumber,
  bonusAmt: FieldType.BigNumber,
  currentAmt: FieldType.BigNumber,
  startedAt: FieldType.DateTime,
  issuedAt: FieldType.DateTime
};
export {
  PlaySpinTxModelConvertSpec
};
